<template>
  <v-container>
    <v-row>
      <v-col lg="12" class="pb-0">
        <h2 style="display: inline-block">{{ title }} Summary</h2>
        <v-btn
          tile
          v-if="!this.$route.query.id"
          style="float: right"
          color="#6490f1"
          dark
          class="mb-2 ml-3"
          @click="onConfirmAdd()"
        >
          <v-icon size="20" class="mr-1">mdi-check-bold</v-icon>Confirm
        </v-btn>
        <v-btn
          tile
          v-if="this.$route.query.id"
          style="float: right"
          color="#6490f1"
          dark
          class="mb-2 ml-3"
          @click="onConfirmEdit()"
        >
          <v-icon size="20" class="mr-1">mdi-check-bold</v-icon>Save changes
        </v-btn>
        <v-btn
          tile
          style="float: right"
          color="#6490f1"
          dark
          class="mb-2"
          @click="onEditSummary()"
        >
          <v-icon size="20" class="mr-1">mdi-pencil</v-icon>Edit
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="12">
        <UnitSummary v-if="this.section == 'units'" :item="item"></UnitSummary>
        <QualificationSummary
          v-if="this.section == 'qualifications'"
          :item="item"
        ></QualificationSummary>
        <LearnerSummary
          v-if="this.section == 'learners'"
          :item="item"
        ></LearnerSummary>
        <CentreSummary
          v-if="this.section == 'centres'"
          :item="item"
        ></CentreSummary>
        <AoSummary v-if="this.section == 'ao'" :item="item"></AoSummary>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UnitSummary from "../components/UnitSummary";
import QualificationSummary from "../components/QualificationSummary";
import LearnerSummary from "../components/LearnerSummary";
import CentreSummary from "../components/CentreSummary";
import AoSummary from "../components/AoSummary";

export default {
  components: {
    UnitSummary,
    QualificationSummary,
    LearnerSummary,
    CentreSummary,
    AoSummary,
  },
  mounted: function () {
    this.section = this.$route.params.section;
    this.item = this.$route.params.item;

    this.getCountries();
    this.getQualifications();
    this.getCertificationTemplates();

    if (this.section == "units") {
      this.redirectComponent = "UnitDetails";
      this.title = "Unit";
      this.onConfirmAdd = this.onAddUnit;
      this.onConfirmEdit = this.onEditUnit;
    } else if (this.section == "qualifications") {
      this.redirectComponent = "QualificationDetails";
      this.title = "Qualification";
      this.onConfirmAdd = this.onAddQualification;
      this.onConfirmEdit = this.onEditQualification;
    } else if (this.section == "learners") {
      this.redirectComponent = "LearnerDetails";
      this.title = "Learner";
      this.onConfirmAdd = this.onAddLearner;
      this.onConfirmEdit = this.onEditLearner;
    } else if (this.section == "centres") {
      this.redirectComponent = "CentreDetails";
      this.title = "Centre";
      this.onConfirmAdd = this.onAddCentre;
      this.onConfirmEdit = this.onEditCentre;
    } else if (this.section == "ao") {
      this.redirectComponent = "AoDetails";
      this.title = "Awarding Organisation";
      this.onConfirmAdd = this.onAddAo;
      this.onConfirmEdit = this.onEditAo;
    }
  },
  data() {
    return {
      mode: null,
      section: null,
      id: null,
      redirectComponent: null,
      title: null,
      item: null,
      onConfirmAdd: null,
      onConfimEdit: null,
      countries: [],
      qualifications: [],
      certificationTemplates: [],
    };
  },
  methods: {
    getCertificationTemplates: async function () {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/templates?type=certification`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      );

      const data = await response.json();
      this.certificationTemplates = data.templates;
    },

    getCertificationTemplateId: function (name) {
      const templates = this.certificationTemplates.filter((template) => {
        return template.name == name;
      });

      return templates.length > 0 ? templates[0]._id : null;
    },

    getCountries: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/countries`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.countries = data.countries;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getQualifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.qualifications = data.qualifications;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    unitMaterials: function () {
      const item = this.item;

      return {
        image: item.image,
        video: item.video,
        brochure: item.brochure,
        guide: item.guide,
      };
    },
    unitItem: function () {
      const item = this.item;

      let imageTitle = "";
      let videoTitle = "";
      let brochureTitle = "";
      let guideTitle = "";

      if (item.image) {
        imageTitle = item.image.name;
      }

      if (item.video) {
        videoTitle = item.video.name;
      }

      if (item.brochure) {
        brochureTitle = item.brochure.name;
      }

      if (item.guide) {
        guideTitle = item.guide.name;
      }

      return {
        name: item.name,
        code: item.code,
        uan: item.uan,
        description: item.description,
        type: item.type,
        level: item.level,
        credits: item.credits,
        status: item.status,
        number: item.number,
        note: item.note,
        startDate: item.startDate,
        reviewDate: item.reviewDate,
        tqt: item.tqt,
        gradingCriterion: item.gradingCriterion,
        gradingLanguage: item.gradingLanguage,
        minimumHour: item.minimumHour,
        noOfResits: item.noOfResits,
        deliveryMode: item.deliveryMode,
        image: imageTitle,
        video: videoTitle,
        brochure: brochureTitle,
        guide: guideTitle,
        learningOutcomes: item.learningOutcomes,
        coursesAssociatedWith: item.coursesAssociatedWith,
      };
    },
    qualificationItem: function () {
      const item = this.item;
      const selectedMandatoryUnitsId = [];
      const selectedOptionalUnitsId = [];
      let imageTitle = "";
      let videoTitle = "";
      let brochureTitle = "";
      let guideTitle = "";

      const certificationId = this.getCertificationTemplateId(
        item.certificationTemplate
      );

      if (item.image) {
        imageTitle = item.image.name;
      }

      if (item.video) {
        videoTitle = item.video.name;
      }

      if (item.brochure) {
        brochureTitle = item.brochure.name;
      }

      if (item.guide) {
        guideTitle = item.guide.name;
      }

      // retrive mandatory unit ID from name
      for (let i = 0; i < item.mandatoryUnits.length; i++) {
        for (let j = 0; j < item.units.length; j++) {
          if (item.units[j].code == item.mandatoryUnits[i]) {
            selectedMandatoryUnitsId.push(item.units[j].id);
          }
        }
      }

      // retrive optional unit ID from name
      for (let i = 0; i < item.optionalUnits.length; i++) {
        for (let j = 0; j < item.units.length; j++) {
          if (item.units[j].code == item.optionalUnits[i]) {
            selectedOptionalUnitsId.push(item.units[j].id);
          }
        }
      }

      return {
        name: item.name,
        code: item.code,
        qan: item.qan,
        description: item.description,
        type: item.type,
        level: item.level,
        credits: item.credits,
        status: item.status,
        note: item.note,
        noOfMandatoryUnits: item.noOfMandatoryUnits,
        mandatoryUnits: selectedMandatoryUnitsId,
        noOfOptionalUnits: item.noOfOptionalUnits,
        optionalUnits: selectedOptionalUnitsId,
        startDate: item.startDate,
        reviewDate: item.reviewDate,
        certificationTemplate: certificationId,
        tqt: item.tqt,
        gradingCriterion: item.gradingCriterion,
        gradingLanguage: item.gradingLanguage,
        minimumHour: item.minimumHour,
        noOfResits: item.noOfResits,
        deliveryMode: item.deliveryMode,
        image: imageTitle,
        video: videoTitle,
        brochure: brochureTitle,
        guide: guideTitle,
      };
    },
    learnerItem: function () {
      const item = this.item;

      item.title = item.title == "Prefer not to say" ? "" : item.title;

      return {
        code: item.code,
        title: item.title,
        centre: item.centre,
        qualification: item.qualification,
        firstApprovedDate: item.firstApprovedDate,
        renewalDate: item.renewalDate,
        ukprn: item.ukprn,
        status: item.status,
        firstName: item.firstName,
        middleName: item.middleName,
        lastName: item.lastName,
        uln: item.uln,
        dateOfBirth: item.dateOfBirth,
        ethnicity: item.ethnicity,
        nationality: item.nationality,
        phoneNo: item.phoneNo,
        mobileNo: item.mobileNo,
        email: item.email,
        addressLine1: item.addressLine1,
        addressLine2: item.addressLine2,
        addressLine3: item.addressLine3,
        city: item.city,
        postCode: item.postCode,
        country: item.country,
      };
    },
    centreItem: function () {
      const item = this.item;

      return {
        code: item.code,
        name: item.name,
        city: item.city,
        firstApprovedDate: item.firstApprovedDate,
        renewalDate: item.renewalDate,
        ukprn: item.ukprn,
        status: item.status,
        addressLine1: item.addressLine1,
        addressLine2: item.addressLine2,
        addressLine3: item.addressLine3,
        postcode: item.postcode,
        country: item.country,
        mainContactFirstName: item.mainContactFirstName,
        mainContactMiddleName: item.mainContactMiddleName,
        mainContactLastName: item.mainContactLastName,
        mainContactEmail: item.mainContactEmail,
        mainContactTelephone: item.mainContactTelephone,
        mainContactMobile: item.mainContactMobile,
        adminContactFirstName: item.adminContactFirstName,
        adminContactMiddleName: item.adminContactMiddleName,
        adminContactLastName: item.adminContactLastName,
        adminContactEmail: item.adminContactEmail,
        adminContactTelephone: item.adminContactTelephone,
        adminContactMobile: item.adminContactMobile,
        accountContactFirstName: item.accountContactFirstName,
        accountContactMiddleName: item.accountContactMiddleName,
        accountContactLastName: item.accountContactLastName,
        accountContactEmail: item.accountContactEmail,
        accountContactTelephone: item.accountContactTelephone,
        accountContactMobile: item.accountContactMobile,
      };
    },
    aoItem: function () {
      const item = this.item;

      return {
        code: item.code,
        name: item.name,
        city: item.city,
        firstApprovedDate: item.firstApprovedDate,
        renewalDate: item.renewalDate,
        status: item.status,
        addressLine1: item.addressLine1,
        addressLine2: item.addressLine2,
        addressLine3: item.addressLine3,
        postcode: item.postcode,
        country: item.country,
        mainContactFirstName: item.mainContactFirstName,
        mainContactMiddleName: item.mainContactMiddleName,
        mainContactLastName: item.mainContactLastName,
        mainContactEmail: item.mainContactEmail,
        mainContactTelephone: item.mainContactTelephone,
        mainContactMobile: item.mainContactMobile,
        adminContactEmail: item.adminContactEmail,
        adminContactTelephone: item.adminContactTelephone,
        adminContactMobile: item.adminContactMobile,
        accountContactEmail: item.accountContactEmail,
        accountContactTelephone: item.accountContactTelephone,
        accountContactMobile: item.accountContactMobile,
      };
    },
    mapCountryNameToId: function (countryName) {
      for (let i = 0; i < this.countries.length; i++) {
        if (countryName == this.countries[i].name) {
          return this.countries[i]._id;
        }
      }
    },
    mapQualificationCodeToId: function (qualificationCodes) {
      const learnerQualifications = [];

      for (let i = 0; i < qualificationCodes.length; i++) {
        for (let j = 0; j < this.qualifications.length; j++) {
          if (qualificationCodes[i] == this.qualifications[j].code) {
            learnerQualifications.push(this.qualifications[j]._id);
          }
        }
      }

      return learnerQualifications;
    },
    onEditSummary: function () {
      if (this.$route.query.id) {
        this.$router.push({
          name: this.redirectComponent,
          query: { id: this.$route.query.id },
          params: { from: "summary" },
        });
      } else if (!this.$route.query.id) {
        this.$router.push({
          name: this.redirectComponent,
          params: { from: "summary", item: this.item },
        });
      }
    },
    uploadUnitResources: function () {
      const item = this.unitMaterials();

      const formData = new FormData();
      formData.append("resources", item.image);
      formData.append("resources", item.video);
      formData.append("resources", item.brochure);
      formData.append("resources", item.guide);

      fetch(`${process.env.VUE_APP_ROOT_API}/units/resources`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onAddUnit: function () {
      this.$store.state.progressStatus = true;

      this.uploadUnitResources();

      fetch(`${process.env.VUE_APP_ROOT_API}/units`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(this.unitItem()),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          this.$router.push({
            name: "Units",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onEditUnit: function () {
      this.$store.state.progressStatus = true;

      this.uploadUnitResources();

      fetch(`${process.env.VUE_APP_ROOT_API}/units/${this.$route.query.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(this.unitItem()),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          this.$router.push({
            name: "Units",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onAddQualification: function () {
      this.$store.state.progressStatus = true;

      this.uploadUnitResources();

      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(this.qualificationItem()),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          this.$router.push({
            name: "Qualifications",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onEditQualification: function () {
      this.$store.state.progressStatus = true;

      this.uploadUnitResources();

      console.log(this.qualificationItem());

      fetch(
        `${process.env.VUE_APP_ROOT_API}/qualifications/${this.$route.query.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(this.qualificationItem()),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (this.$route.params.from == "summary") {
            this.$router.push({
              path: `/qualifications/summary?id=${this.$route.query.id}`,
            });
          } else {
            this.$store.state.progressStatus = false;

            this.$router.push({
              name: "Qualifications",
              params: { message: data.message },
            });
          }
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onAddCentre: function () {
      this.$store.state.progressStatus = true;

      fetch(`${process.env.VUE_APP_ROOT_API}/centres`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(this.centreItem()),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          this.$router.push({
            name: "Centres",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onEditCentre: function () {
      this.$store.state.progressStatus = true;

      fetch(`${process.env.VUE_APP_ROOT_API}/centres/${this.$route.query.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(this.centreItem()),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          if (this.$route.params.from == "summary") {
            this.$router.push({
              path: `/centres/summary?id=${this.$route.query.id}`,
            });
          } else {
            this.$router.push({
              name: "Centres",
              params: { message: data.message },
            });
          }
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onAddLearner: function () {
      this.$store.state.progressStatus = true;

      const learner = this.learnerItem();
      learner.qualification = this.mapQualificationCodeToId(
        learner.qualification
      ); // insert qualification id instead of qualification name for reference

      fetch(`${process.env.VUE_APP_ROOT_API}/learners`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(learner),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          this.$router.push({
            name: "Learners",
            params: { message: data.message, status: 0 },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onEditLearner: function () {
      this.$store.state.progressStatus = true;

      const learner = this.learnerItem();
      learner.qualification = this.mapQualificationCodeToId(
        learner.qualification
      ); // insert qualification id instead of qualification name for reference

      fetch(
        `${process.env.VUE_APP_ROOT_API}/learners/${this.$route.query.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(learner),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          if (this.$route.params.from == "summary") {
            this.$router.push({
              path: `/learners/summary?id=${this.$route.query.id}`,
            });
          } else {
            this.$router.push({
              name: "Learners",
              params: { message: data.message, status: 0 },
            });
          }
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onAddAo: function () {
      this.$store.state.progressStatus = true;

      const ao = this.aoItem();
      ao.country = this.mapCountryNameToId(ao.country); // insert country id instead of country name for reference

      fetch(`${process.env.VUE_APP_ROOT_API}/ao`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(ao),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;
          this.$store.commit("refreshView");

          this.$router.push({
            name: "Dashboard",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
    onEditAo: function () {
      this.$store.state.progressStatus = true;

      const ao = this.aoItem();
      ao.country = this.mapCountryNameToId(ao.country); // insert country id instead of country name for reference

      fetch(`${process.env.VUE_APP_ROOT_API}/ao/${this.$route.query.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(ao),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.state.progressStatus = false;

          if (this.$route.params.from == "summary") {
            this.$router.push({
              path: `/ao/summary?id=${this.$route.query.id}`,
            });
          } else {
            this.$router.push({
              name: "Dashboard",
              params: { message: data.message },
            });
          }
        })
        .catch((error) => {
          this.$store.state.progressStatus = false;
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
</style>